import React, { useEffect, useMemo, useState } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReportingColumn } from 'interfaces/report-configuration.interface';
import { SelectFormInput } from 'shared-components';
import ModalControlButtons from 'shared-components/ModalControlButtons';

type Props = {
  control: any;
  selectedColumnsData: ReportingColumn[];
  onCloseModal: VoidFunction;
  onSubmit: (groupColumn: string) => void;
  selectedGroupingColumns: string[];
  selectedGroupingColumnName?: string;
};

const CreateReportTemplateGroupingModal: React.FC<Props> = ({
  control,
  selectedColumnsData,
  onCloseModal,
  onSubmit,
  selectedGroupingColumns,
  selectedGroupingColumnName,
}) => {
  const { t } = useTranslation();
  const [grouping, setGrouping] = useState<string>('');
  const selectedTable = useWatch({
    control,
    name: 'selectedTable',
  });
  const { setValue } = useFormContext();

  const availableColumns = useMemo(() => {
    if (!selectedTable?.value || !Array.isArray(selectedColumnsData)) {
      return [];
    }

    return selectedColumnsData
      .filter((col) => col.tableName === selectedTable.value && selectedGroupingColumns.includes(col.name))
      .map((col) => ({
        label: col.name,
        value: col.name,
      }));
  }, [selectedTable, selectedColumnsData, selectedGroupingColumns]);

  useEffect(() => {
    if (availableColumns.length && selectedGroupingColumnName) {
      const selectedOption = availableColumns.find((o) => o.value === selectedGroupingColumnName);
      if (selectedOption) {
        setValue('grouping', selectedOption);
        setGrouping(selectedOption.value);
      }
    }
  }, [availableColumns, selectedGroupingColumns, setValue]);

  return (
    <div className="pt-4 mb-2">
      <SelectFormInput
        inputClassName="!w-[22rem]"
        name="grouping"
        control={control}
        options={availableColumns}
        placeholder={t('Select column')}
        onSelectValue={(option) => setGrouping(option?.value ?? '')}
        defaultValue={availableColumns.find((o) => o.value === selectedGroupingColumnName)}
      />
      <ModalControlButtons
        onClose={onCloseModal}
        saveButtonText={t('Save')}
        disabled={!grouping}
        onSubmit={() => onSubmit(grouping)}
      />
    </div>
  );
};

export default CreateReportTemplateGroupingModal;
